import React, { Component } from "react";
import InputMask from 'react-input-mask';
import { BrowserRouter as Router, Route, Switch, NavLink, Redirect } from "react-router-dom";
import { translate } from 'react-i18next';
import QRCode from "react-qr-code";
import { request } from "../../../../config";

class IndividualSima extends Component {

    state = {
        code: null,
    }

    createSimaQr = (event) => {
        event.preventDefault();
        this.props.updateAppState('isLoadingTransparentBackground', true);

        fetch(request("register/simaQr", null, "GET"))
            .then((res) => res.json())
            .then((getSimaQrResponse) => {
                if (getSimaQrResponse.status.statusCode !== 1) {
                    this.setState({ feedbackMessage: this.props.t(getSimaQrResponse.status.statusCode) });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
                else {
                    this.setState({ code: getSimaQrResponse.qrUrl, operationId: getSimaQrResponse.operationId }, () => this.checkStatus())
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            });
    }

    checkStatus = () => {
        this.intervalId = setInterval(async () => {
            await fetch(request(`register/simaQr/${this.state.operationId}`, null, "GET"))
                .then((res) => res.json())
                .then((checkStatusResponse) => {
                    if (checkStatusResponse.status.statusCode === 1) {
                        clearInterval(this.intervalId);
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                        this.props.history.push("sima/confirmation", { token: checkStatusResponse.token });
                    } else if (checkStatusResponse.status.statusCode === 583) {
                        this.props.updateAppState('isLoadingTransparentBackground', true);
                    }
                    else if (checkStatusResponse.status.statusCode !== 581) {
                        clearInterval(this.intervalId);
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                        this.setState({ feedbackMessage: this.props.t(checkStatusResponse.status.statusCode), code: null });
                    }
                },
                    (error) => {
                        this.props.history.push("/technical-break");
                    });
        }, 3000)
    }

    render() {
        let { code, feedbackMessage } = this.state;
        let { t } = this.props;
        return (
            <form className="header-sign-section-container-form-sima">
                <ul className="header-sign-section-container-form-sima-list">
                    <li>{t('Open the Sima mobile app')}</li>
                    <li>{t('Press the \"Scan\" button')}</li>
                    <li>{t('Log in by scanning the QR code')}</li>
                </ul>
                <div className="header-sign-section-container-form-sima-qr-box">
                    <svg xmlns="http://www.w3.org/2000/svg" width="284" height="284" viewBox="0 0 284 284" fill="none">
                        <path d="M102 2H7C4.23858 2 2 4.23858 2 7V102" stroke="#959FA5" stroke-width="3" />
                        <path d="M282 102L282 7C282 4.23858 279.761 2 277 2L182 2" stroke="#959FA5" stroke-width="3" />
                        <path d="M182 282L277 282C279.761 282 282 279.761 282 277L282 184" stroke="#959FA5" stroke-width="3" />
                        <path d="M2.00001 184L2 277C2 279.761 4.23858 282 7 282L102 282" stroke="#959FA5" stroke-width="3" />
                    </svg>
                    {code ? <QRCode
                        className="header-sign-section-container-form-sima-qr-box-button w-75"
                        value={code} />
                        :
                        <button className="header-sign-section-container-form-sima-qr-box-button header-sign-section-container-form-button"
                            onClick={this.createSimaQr}>
                            {t('Create QR code')}
                        </button>
                    }
                </div>
                <div className="registration-container-validation-feedback">
                    {
                        feedbackMessage ? <p className="registration-container-validation-feedback-message">{feedbackMessage}</p> : null
                    }
                </div>
                <div className="header-sign-section-container-form-group">
                    <a href="https://sima.az/" target="_blank">{t('What is SİMA')}</a>
                </div>
            </form>
        )
    };
};

export default translate("translation")(IndividualSima);
